module.exports = __webpack_public_path__ + "static/media/main-profile.d7f2a278.png";